<div class="variant-snackbar">
    <div class="variant-snackbar-container">
        <div class="message">
            {{ variantsCount }} variants have been updated.
        </div>
        <div (click)="undoUpdateVariants()" class="variant-undo">Undo</div>
        <mat-icon
            class="variant-snackbar-close"
            (click)="closeUpdateAlertSnackBar()"
            >close</mat-icon
        >
    </div>
</div>
